import React, { PropTypes } from 'react';
import { ListGroup, ListGroupItem, Collapse } from 'react-bootstrap';
import ShopCategoryList from './ShopCategoryList';

class ShopList extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         shopOpen: -1
      };
   }

   changeOpenShop = (shopIndex) => {
      this.setState({
         shopOpen: (shopIndex === this.state.shopOpen) ? -1 : shopIndex
      });
   };

   render() {
      const { shops, addCategory, addSubCategory } = this.props;
      const { shopOpen } = this.state;
      return (
         <ListGroup>
            {shops.map((shop, shopIndex) => (
               <ListGroupItem key={shop.id} className={shopOpen === shopIndex ? 'opened' : null} >
                  <span onClick={() => this.changeOpenShop(shopIndex)} >{shop.name}</span>
                  <Collapse in={shopOpen === shopIndex} >
                     <div>
                        {shop.categories
                        &&
                        <ShopCategoryList
                           categories={shop.categories}
                           addCategory={addCategory}
                           addSubCategory={addSubCategory}
                           shopId={shop.id} />}
                     </div>
                  </Collapse>
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

ShopList.propTypes = {
   shops: PropTypes.array.isRequired,
   addCategory: PropTypes.func,
   addSubCategory: PropTypes.func
};
export default ShopList;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainLocation/ShopList.js
 **/